"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const _hoisted_1 = { class: "2xl:container mx-auto p-4" };
const _hoisted_2 = { class: "text-xl sm:text-2xl mb-4 sm:my-5 sm:ml-5 font-bold uppercase text-center sm:text-left" };
const _hoisted_3 = { class: "bg-white p-5 mb-4 text-base sm:text-xl" };
const _hoisted_4 = { class: "uppercase font-bold border-b-1 border-gray pb-3" };
const _hoisted_5 = { class: "flex flex-col p-4" };
const _hoisted_6 = {
    key: 0,
    class: "bg-white p-5 mb-4 text-base sm:text-xl"
};
const _hoisted_7 = { class: "uppercase font-bold border-b-1 border-gray pb-3" };
const _hoisted_8 = { class: "flex flex-col p-4" };
const _hoisted_9 = {
    key: 0,
    class: "bg-white p-5 mb-4 text-base sm:text-xl"
};
const _hoisted_10 = { class: "uppercase font-bold border-b-1 border-gray pb-3" };
const _hoisted_11 = { class: "flex flex-col sm:flex-row sm:flex-wrap p-4" };
const _hoisted_12 = {
    key: 0,
    class: "bg-white p-5 mb-4 text-base sm:text-xl"
};
const _hoisted_13 = {
    key: 0,
    class: "uppercase font-bold border-b-1 border-gray pb-3"
};
const _hoisted_14 = {
    key: 1,
    class: "uppercase font-bold border-b-1 border-gray pb-3"
};
const _hoisted_15 = {
    key: 2,
    class: "uppercase font-bold border-b-1 border-gray pb-3"
};
const _hoisted_16 = {
    key: 3,
    class: "flex flex-col sm:flex-row sm:flex-wrap p-4"
};
const _hoisted_17 = {
    key: 4,
    class: "flex flex-col sm:flex-row sm:flex-wrap p-4"
};
const _hoisted_18 = {
    key: 5,
    class: "flex flex-col sm:flex-row sm:flex-wrap p-4"
};
const _hoisted_19 = {
    key: 0,
    class: "bg-white p-5 mb-4 text-base sm:text-xl"
};
const _hoisted_20 = { class: "uppercase font-bold pb-3" };
const _hoisted_21 = {
    key: 0,
    class: "flex justify-center"
};
const vue_3 = require("vue");
const i18n_1 = require("../../common/i18n");
const PricingEnum_1 = require("../../stores/pricing/PricingEnum");
const vue_router_1 = require("vue-router");
const pricingStore_1 = require("../../stores/pricing/pricingStore");
const toastStore_1 = require("../../stores/toast/toastStore");
const Form_1 = require("../../components/Form");
const tyre_search_1 = require("../../components/ProductSearch/tyre-search");
const PricingOptionRadio_vue_1 = __importDefault(require("./PricingOptionRadio.vue"));
exports.default = (0, vue_1.defineComponent)({
    __name: 'NewPricing',
    setup(__props) {
        const router = (0, vue_router_1.useRouter)();
        const pricingStore = (0, pricingStore_1.usePricingStore)();
        const toastStore = (0, toastStore_1.useToastStore)();
        const pricingNameStep = (0, vue_3.ref)("");
        const pricingBasePriceTypeTranslations = {
            [PricingEnum_1.PricingBasePriceTypeEnum.RETAIL]: (0, i18n_1.trans)('retail', 'Retail', 'new_pricing'),
            [PricingEnum_1.PricingBasePriceTypeEnum.WHOLESALE]: (0, i18n_1.trans)('wholesale', 'Wholesale', 'new_pricing'),
        };
        const pricingTypeTranslations = {
            [PricingEnum_1.PricingTypeEnum.PERCENT]: (0, i18n_1.trans)('percent', 'Percent', 'new_pricing'),
            [PricingEnum_1.PricingTypeEnum.FIXED]: (0, i18n_1.trans)('fixed', 'Fixed', 'new_pricing'),
        };
        const pricingTyreCategoryTranslations = {
            [PricingEnum_1.PricingTyreCategoryEnum.PASSENGER_TYRES]: (0, i18n_1.trans)('passenger_tyres', 'Passenger tyres', 'new_pricing'),
            [PricingEnum_1.PricingTyreCategoryEnum.TRUCK_TYRES]: (0, i18n_1.trans)('truck_tyres', 'Truck tyres', 'new_pricing'),
            [PricingEnum_1.PricingTyreCategoryEnum.AGRICULTURAL_AND_INDUSTRIAL_TYRES]: (0, i18n_1.trans)('agricultural_industrial_tyres', 'Agricultural and industrial tyres', 'new_pricing'),
            [PricingEnum_1.PricingTyreCategoryEnum.FORKLIFT_TYRES]: (0, i18n_1.trans)('forklift_tyres', 'Forklift tyres', 'new_pricing'),
            [PricingEnum_1.PricingTyreCategoryEnum.MOTORCYCLE_TYRES]: (0, i18n_1.trans)('motorcycle_tyres', 'Motorcycle tyres', 'new_pricing'),
            [PricingEnum_1.PricingTyreCategoryEnum.SPARE_WHEELS]: (0, i18n_1.trans)('spare_wheels', 'Spare wheels', 'new_pricing'),
            [PricingEnum_1.PricingTyreCategoryEnum.RIMS]: (0, i18n_1.trans)('rims', 'Rims', 'new_pricing'),
            [PricingEnum_1.PricingTyreCategoryEnum.TUBES_AND_TAPES]: (0, i18n_1.trans)('tubes_and_tapes', 'Tubes and tapes', 'pricing')
        };
        const pricingOptionTranslations = {
            [PricingEnum_1.PricingPassengerTyreSeasonEnum.SUMMER_TYRE]: (0, i18n_1.trans)('summer_tyre', 'Summer tyre', 'new_pricing'),
            [PricingEnum_1.PricingPassengerTyreSeasonEnum.WINTER_TYRE]: (0, i18n_1.trans)('winter_tyre', 'Winter tyre', 'new_pricing'),
            [PricingEnum_1.PricingPassengerTyreSeasonEnum.ALL_SEASON_TYRE]: (0, i18n_1.trans)('all_season_tyre', 'All season tyre', 'new_pricing'),
            [PricingEnum_1.PricingTruckTyreTypeEnum.RETREADED_TYRE]: (0, i18n_1.trans)('retreaded_tyre', 'Retreaded tyre', 'new_pricing'),
            [PricingEnum_1.PricingTruckTyreTypeEnum.TUBELESS_TYRE]: (0, i18n_1.trans)('tubeless_tyre', 'Tubeless tyre', 'new_pricing'),
            [PricingEnum_1.PricingTruckTyreTypeEnum._20_INCHES_TYRE]: (0, i18n_1.trans)('20_inches_tyre', '20 inches tyre', 'new_pricing'),
            [PricingEnum_1.PricingRimCategoryEnum.STEEL_RIM]: (0, i18n_1.trans)('steel_rim', 'Steel rim', 'new_pricing'),
            [PricingEnum_1.PricingRimCategoryEnum.ALLOY_RIM]: (0, i18n_1.trans)('alloy_rim', 'Alloy rim', 'new_pricing'),
            [PricingEnum_1.PricingRimCategoryEnum.AGRICULTURAL_RIM]: (0, i18n_1.trans)('agricultural_rim', 'Agricultural rim', 'new_pricing'),
            [PricingEnum_1.PricingRimCategoryEnum.TWIN_WHEELS]: (0, i18n_1.trans)('twin_wheels', 'Twin wheels', 'new_pricing')
        };
        (0, vue_3.onUnmounted)(() => {
            const currentRouteName = router.currentRoute.value.name;
            if (currentRouteName !== 'percent_pricing' && currentRouteName !== 'fixed_pricing') {
                pricingStore.resetState();
            }
        });
        // Ax kategóriák meghatározása.
        const getAxCategories = () => {
            // Személy.
            if (pricingStore.pricingTyreCategoryOption === PricingEnum_1.PricingTyreCategoryEnum.PASSENGER_TYRES) {
                if (pricingStore.pricingPassengerTyreSeasonOption === PricingEnum_1.PricingPassengerTyreSeasonEnum.SUMMER_TYRE) {
                    return [...Object.values(tyre_search_1.seasonRules.summer)];
                }
                else if (pricingStore.pricingPassengerTyreSeasonOption === PricingEnum_1.PricingPassengerTyreSeasonEnum.WINTER_TYRE) {
                    return [...Object.values(tyre_search_1.seasonRules.winter)];
                }
                else {
                    return [...Object.values(tyre_search_1.seasonRules.all_season)];
                }
            }
            // Teher.
            if (pricingStore.pricingTyreCategoryOption === PricingEnum_1.PricingTyreCategoryEnum.TRUCK_TYRES) {
                if (pricingStore.pricingTruckTyreTypeOption === PricingEnum_1.PricingTruckTyreTypeEnum.TUBELESS_TYRE) {
                    return ["122"];
                }
                else if (pricingStore.pricingTruckTyreTypeOption === PricingEnum_1.PricingTruckTyreTypeEnum._20_INCHES_TYRE) {
                    return ["120"];
                }
                else {
                    return ["123", "127"];
                }
            }
            // Mezőgazdasági.
            if (pricingStore.pricingTyreCategoryOption === PricingEnum_1.PricingTyreCategoryEnum.AGRICULTURAL_AND_INDUSTRIAL_TYRES) {
                return ["110", "160"];
            }
            // Targonca.
            if (pricingStore.pricingTyreCategoryOption === PricingEnum_1.PricingTyreCategoryEnum.FORKLIFT_TYRES) {
                return ["150"];
            }
            // Motor.
            if (pricingStore.pricingTyreCategoryOption === PricingEnum_1.PricingTyreCategoryEnum.MOTORCYCLE_TYRES) {
                return ["170"];
            }
            // Pótkerék.
            if (pricingStore.pricingTyreCategoryOption === PricingEnum_1.PricingTyreCategoryEnum.SPARE_WHEELS) {
                return ["910"];
            }
            // Felnik.
            if (pricingStore.pricingTyreCategoryOption === PricingEnum_1.PricingTyreCategoryEnum.RIMS) {
                if (pricingStore.pricingRimCategoryOption === PricingEnum_1.PricingRimCategoryEnum.ALLOY_RIM) {
                    return ["445"];
                }
                else if (pricingStore.pricingRimCategoryOption === PricingEnum_1.PricingRimCategoryEnum.STEEL_RIM) {
                    return ["440"];
                }
                else if (pricingStore.pricingRimCategoryOption === PricingEnum_1.PricingRimCategoryEnum.TWIN_WHEELS) {
                    return ["415"];
                }
                else {
                    return ["410"];
                }
            }
            // Tömlők és szalagok.
            if (pricingStore.pricingTyreCategoryOption === PricingEnum_1.PricingTyreCategoryEnum.TUBES_AND_TAPES) {
                return ["210", "220", "230", "240", "250", "260", "270", "280", "310", "320", "350", "360", "370"];
            }
            return [];
        };
        const showFourthStep = () => {
            return pricingStore.pricingTyreCategoryOption &&
                (pricingStore.pricingTyreCategoryOption !== PricingEnum_1.PricingTyreCategoryEnum.AGRICULTURAL_AND_INDUSTRIAL_TYRES &&
                    pricingStore.pricingTyreCategoryOption !== PricingEnum_1.PricingTyreCategoryEnum.FORKLIFT_TYRES &&
                    pricingStore.pricingTyreCategoryOption !== PricingEnum_1.PricingTyreCategoryEnum.MOTORCYCLE_TYRES &&
                    pricingStore.pricingTyreCategoryOption !== PricingEnum_1.PricingTyreCategoryEnum.SPARE_WHEELS &&
                    pricingStore.pricingTyreCategoryOption !== PricingEnum_1.PricingTyreCategoryEnum.TUBES_AND_TAPES);
        };
        const showFourthStepCategoryText = () => {
            return pricingStore.pricingTyreCategoryOption === PricingEnum_1.PricingTyreCategoryEnum.RIMS;
        };
        const showPricingNameField = () => {
            if (pricingStore.pricingTyreCategoryOption === PricingEnum_1.PricingTyreCategoryEnum.AGRICULTURAL_AND_INDUSTRIAL_TYRES ||
                pricingStore.pricingTyreCategoryOption === PricingEnum_1.PricingTyreCategoryEnum.FORKLIFT_TYRES ||
                pricingStore.pricingTyreCategoryOption === PricingEnum_1.PricingTyreCategoryEnum.MOTORCYCLE_TYRES ||
                pricingStore.pricingTyreCategoryOption === PricingEnum_1.PricingTyreCategoryEnum.SPARE_WHEELS ||
                pricingStore.pricingTyreCategoryOption === PricingEnum_1.PricingTyreCategoryEnum.TUBES_AND_TAPES) {
                pricingNameStep.value = "4";
                return true;
            }
            else if (pricingStore.pricingPassengerTyreSeasonOption ||
                pricingStore.pricingTruckTyreTypeOption ||
                pricingStore.pricingRimCategoryOption) {
                pricingNameStep.value = "5";
                return true;
            }
            else {
                return false;
            }
        };
        const createPricingName = () => {
            if (!pricingStore.pricingBasePriceTypeOption ||
                !pricingStore.pricingTypeOption ||
                !pricingStore.pricingTyreCategoryOption)
                return;
            let name = "";
            let namePart1 = "";
            let namePart2 = "";
            let namePart3 = "";
            let namePart4 = "";
            namePart1 = pricingBasePriceTypeTranslations[pricingStore.pricingBasePriceTypeOption];
            name += `${namePart1}`;
            namePart2 = pricingTyreCategoryTranslations[pricingStore.pricingTyreCategoryOption];
            name += ` - ${namePart2}`;
            const options = [
                pricingStore.pricingPassengerTyreSeasonOption,
                pricingStore.pricingTruckTyreTypeOption,
                pricingStore.pricingRimCategoryOption
            ];
            options.forEach(option => {
                if (option) {
                    namePart3 = pricingOptionTranslations[option];
                    if (namePart3) {
                        name += ` - ${namePart3}`;
                    }
                }
            });
            namePart4 = pricingTypeTranslations[pricingStore.pricingTypeOption];
            name += ` - ${namePart4}`;
            const currentDate = new Date();
            const year = currentDate.getFullYear();
            const month = String(currentDate.getMonth() + 1).padStart(2, '0');
            const day = String(currentDate.getDate()).padStart(2, '0');
            name += ` - ${year}.${month}.${day}`;
            pricingStore.pricingName = name;
        };
        const createPricing = async () => {
            if (pricingStore.pricingName &&
                pricingStore.pricingTypeOption &&
                pricingStore.pricingTyreCategoryOption &&
                pricingStore.axCategories.length) {
                try {
                    const response = await pricingStore.createPricing(router, {
                        name: pricingStore.pricingName,
                        type: pricingStore.pricingTypeOption,
                        pricedCategory: pricingStore.pricingTyreCategoryOption,
                        axCategories: pricingStore.axCategories,
                        basePriceType: pricingStore.pricingBasePriceTypeOption
                    });
                    const pricingId = response.id;
                    const pricingStatus = response.status;
                    pricingStore.pricingId = pricingId;
                    pricingStore.pricingStatus = pricingStatus;
                    toastStore.addToast({
                        message: (0, i18n_1.trans)("pricing_created_successfully", "Pricing created successfully!", "new_pricing"),
                        type: "success",
                        timer: 5,
                    });
                    navigateToEditPricing();
                }
                catch (error) {
                    toastStore.addErrorToast(error.toString());
                }
            }
        };
        const navigateToEditPricing = () => {
            const routeName = pricingStore.pricingTypeOption === PricingEnum_1.PricingTypeEnum.PERCENT ? 'percent_pricing' : 'fixed_pricing';
            router.push({ name: routeName });
        };
        (0, vue_3.watch)(() => [
            pricingStore.pricingTyreCategoryOption,
            pricingStore.pricingPassengerTyreSeasonOption,
            pricingStore.pricingTruckTyreTypeOption,
            pricingStore.pricingRimCategoryOption
        ], ([newTyreCategoryOption], [oldTyreCategoryOption]) => {
            if (newTyreCategoryOption !== oldTyreCategoryOption) {
                pricingStore.resetPricingOptions();
            }
            pricingStore.axCategories = getAxCategories();
        });
        (0, vue_3.watch)(() => [
            pricingStore.pricingBasePriceTypeOption,
            pricingStore.pricingTypeOption,
            pricingStore.pricingTyreCategoryOption,
            pricingStore.pricingPassengerTyreSeasonOption,
            pricingStore.pricingTruckTyreTypeOption,
            pricingStore.pricingRimCategoryOption
        ], () => {
            createPricingName();
        });
        return (_ctx, _cache) => {
            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_1, [
                (0, vue_2.createElementVNode)("div", _hoisted_2, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)('new_pricing', 'New pricing', 'new_pricing')), 1),
                (0, vue_2.createVNode)(vue_2.Transition, { name: "fade" }, {
                    default: (0, vue_2.withCtx)(() => [
                        (0, vue_2.createElementVNode)("div", _hoisted_3, [
                            (0, vue_2.createElementVNode)("div", _hoisted_4, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)('pricing_step_1', 'Step 1: Decide what you want to base your pricing on', 'new_pricing')), 1),
                            (0, vue_2.createElementVNode)("div", _hoisted_5, [
                                (0, vue_2.createVNode)(PricingOptionRadio_vue_1.default, {
                                    modelValue: (0, vue_2.unref)(pricingStore).pricingBasePriceTypeOption,
                                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => (((0, vue_2.unref)(pricingStore).pricingBasePriceTypeOption) = $event)),
                                    value: (0, vue_2.unref)(PricingEnum_1.PricingBasePriceTypeEnum).RETAIL,
                                    label: (0, vue_2.unref)(i18n_1.trans)('retail_price', 'Retail price', 'new_pricing')
                                }, null, 8, ["modelValue", "value", "label"]),
                                (0, vue_2.createVNode)(PricingOptionRadio_vue_1.default, {
                                    modelValue: (0, vue_2.unref)(pricingStore).pricingBasePriceTypeOption,
                                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => (((0, vue_2.unref)(pricingStore).pricingBasePriceTypeOption) = $event)),
                                    value: (0, vue_2.unref)(PricingEnum_1.PricingBasePriceTypeEnum).WHOLESALE,
                                    label: (0, vue_2.unref)(i18n_1.trans)('wholesale_price', 'Wholesale price', 'new_pricing')
                                }, null, 8, ["modelValue", "value", "label"])
                            ])
                        ])
                    ]),
                    _: 1
                }),
                (0, vue_2.createVNode)(vue_2.Transition, { name: "fade" }, {
                    default: (0, vue_2.withCtx)(() => [
                        ((0, vue_2.unref)(pricingStore).pricingBasePriceTypeOption)
                            ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_6, [
                                (0, vue_2.createElementVNode)("div", _hoisted_7, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)('pricing_step_2', 'Step 2: Choose how you want to calculate your prices', 'new_pricing')), 1),
                                (0, vue_2.createElementVNode)("div", _hoisted_8, [
                                    (0, vue_2.createVNode)(PricingOptionRadio_vue_1.default, {
                                        modelValue: (0, vue_2.unref)(pricingStore).pricingTypeOption,
                                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => (((0, vue_2.unref)(pricingStore).pricingTypeOption) = $event)),
                                        value: (0, vue_2.unref)(PricingEnum_1.PricingTypeEnum).PERCENT,
                                        label: (0, vue_2.unref)(i18n_1.trans)('percent_pricing', 'Percent pricing', 'new_pricing')
                                    }, null, 8, ["modelValue", "value", "label"]),
                                    (0, vue_2.createVNode)(PricingOptionRadio_vue_1.default, {
                                        modelValue: (0, vue_2.unref)(pricingStore).pricingTypeOption,
                                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => (((0, vue_2.unref)(pricingStore).pricingTypeOption) = $event)),
                                        value: (0, vue_2.unref)(PricingEnum_1.PricingTypeEnum).FIXED,
                                        label: (0, vue_2.unref)(i18n_1.trans)('fixed_pricing', 'Fixed pricing', 'new_pricing')
                                    }, null, 8, ["modelValue", "value", "label"])
                                ])
                            ]))
                            : (0, vue_2.createCommentVNode)("", true)
                    ]),
                    _: 1
                }),
                (0, vue_2.createVNode)(vue_2.Transition, { name: "fade" }, {
                    default: (0, vue_2.withCtx)(() => [
                        ((0, vue_2.unref)(pricingStore).pricingTypeOption)
                            ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_9, [
                                (0, vue_2.createElementVNode)("div", _hoisted_10, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)('pricing_step_3', 'Step 3: Decide which products you are pricing', 'new_pricing')), 1),
                                (0, vue_2.createElementVNode)("div", _hoisted_11, [
                                    (0, vue_2.createVNode)(PricingOptionRadio_vue_1.default, {
                                        modelValue: (0, vue_2.unref)(pricingStore).pricingTyreCategoryOption,
                                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => (((0, vue_2.unref)(pricingStore).pricingTyreCategoryOption) = $event)),
                                        value: (0, vue_2.unref)(PricingEnum_1.PricingTyreCategoryEnum).PASSENGER_TYRES,
                                        label: (0, vue_2.unref)(i18n_1.trans)('passenger_tyres', 'Passenger tyres', 'new_pricing')
                                    }, null, 8, ["modelValue", "value", "label"]),
                                    (0, vue_2.createVNode)(PricingOptionRadio_vue_1.default, {
                                        modelValue: (0, vue_2.unref)(pricingStore).pricingTyreCategoryOption,
                                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event) => (((0, vue_2.unref)(pricingStore).pricingTyreCategoryOption) = $event)),
                                        value: (0, vue_2.unref)(PricingEnum_1.PricingTyreCategoryEnum).TRUCK_TYRES,
                                        label: (0, vue_2.unref)(i18n_1.trans)('truck_tyres', 'Truck tyres', 'new_pricing')
                                    }, null, 8, ["modelValue", "value", "label"]),
                                    (0, vue_2.createVNode)(PricingOptionRadio_vue_1.default, {
                                        modelValue: (0, vue_2.unref)(pricingStore).pricingTyreCategoryOption,
                                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event) => (((0, vue_2.unref)(pricingStore).pricingTyreCategoryOption) = $event)),
                                        value: (0, vue_2.unref)(PricingEnum_1.PricingTyreCategoryEnum).AGRICULTURAL_AND_INDUSTRIAL_TYRES,
                                        label: (0, vue_2.unref)(i18n_1.trans)('agricultural_and_industrial_tyres', 'Agricultural and industrial tyres', 'new_pricing')
                                    }, null, 8, ["modelValue", "value", "label"]),
                                    (0, vue_2.createVNode)(PricingOptionRadio_vue_1.default, {
                                        modelValue: (0, vue_2.unref)(pricingStore).pricingTyreCategoryOption,
                                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event) => (((0, vue_2.unref)(pricingStore).pricingTyreCategoryOption) = $event)),
                                        value: (0, vue_2.unref)(PricingEnum_1.PricingTyreCategoryEnum).FORKLIFT_TYRES,
                                        label: (0, vue_2.unref)(i18n_1.trans)('forklift_tyres', 'Forklift tyres', 'new_pricing')
                                    }, null, 8, ["modelValue", "value", "label"]),
                                    (0, vue_2.createVNode)(PricingOptionRadio_vue_1.default, {
                                        modelValue: (0, vue_2.unref)(pricingStore).pricingTyreCategoryOption,
                                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event) => (((0, vue_2.unref)(pricingStore).pricingTyreCategoryOption) = $event)),
                                        value: (0, vue_2.unref)(PricingEnum_1.PricingTyreCategoryEnum).MOTORCYCLE_TYRES,
                                        label: (0, vue_2.unref)(i18n_1.trans)('motorcycle_tyres', 'Motorcycle tyres', 'new_pricing')
                                    }, null, 8, ["modelValue", "value", "label"]),
                                    (0, vue_2.createVNode)(PricingOptionRadio_vue_1.default, {
                                        modelValue: (0, vue_2.unref)(pricingStore).pricingTyreCategoryOption,
                                        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event) => (((0, vue_2.unref)(pricingStore).pricingTyreCategoryOption) = $event)),
                                        value: (0, vue_2.unref)(PricingEnum_1.PricingTyreCategoryEnum).TUBES_AND_TAPES,
                                        label: (0, vue_2.unref)(i18n_1.trans)('tubes_and_tapes', 'Tubes and tapes', 'new_pricing')
                                    }, null, 8, ["modelValue", "value", "label"])
                                ])
                            ]))
                            : (0, vue_2.createCommentVNode)("", true)
                    ]),
                    _: 1
                }),
                (0, vue_2.createVNode)(vue_2.Transition, { name: "fade" }, {
                    default: (0, vue_2.withCtx)(() => [
                        (showFourthStep())
                            ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_12, [
                                ((0, vue_2.unref)(pricingStore).pricingTyreCategoryOption === (0, vue_2.unref)(PricingEnum_1.PricingTyreCategoryEnum).PASSENGER_TYRES)
                                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_13, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)('pricing_step_4_season', 'Step 4: Decide which season you are pricing for', 'new_pricing')), 1))
                                    : (0, vue_2.createCommentVNode)("", true),
                                ((0, vue_2.unref)(pricingStore).pricingTyreCategoryOption === (0, vue_2.unref)(PricingEnum_1.PricingTyreCategoryEnum).TRUCK_TYRES)
                                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_14, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)('pricing_step_4_truck', 'Step 4: Decide which type you are pricing for', 'new_pricing')), 1))
                                    : (0, vue_2.createCommentVNode)("", true),
                                (showFourthStepCategoryText())
                                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_15, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)('pricing_step_4_category', 'Step 4: Decide which category you are pricing for', 'new_pricing')), 1))
                                    : (0, vue_2.createCommentVNode)("", true),
                                ((0, vue_2.unref)(pricingStore).pricingTyreCategoryOption === (0, vue_2.unref)(PricingEnum_1.PricingTyreCategoryEnum).PASSENGER_TYRES)
                                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_16, [
                                        (0, vue_2.createVNode)(PricingOptionRadio_vue_1.default, {
                                            modelValue: (0, vue_2.unref)(pricingStore).pricingPassengerTyreSeasonOption,
                                            "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event) => (((0, vue_2.unref)(pricingStore).pricingPassengerTyreSeasonOption) = $event)),
                                            value: (0, vue_2.unref)(PricingEnum_1.PricingPassengerTyreSeasonEnum).SUMMER_TYRE,
                                            label: (0, vue_2.unref)(i18n_1.trans)('summer_tyre', 'Summer tyre', 'new_pricing')
                                        }, null, 8, ["modelValue", "value", "label"]),
                                        (0, vue_2.createVNode)(PricingOptionRadio_vue_1.default, {
                                            modelValue: (0, vue_2.unref)(pricingStore).pricingPassengerTyreSeasonOption,
                                            "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event) => (((0, vue_2.unref)(pricingStore).pricingPassengerTyreSeasonOption) = $event)),
                                            value: (0, vue_2.unref)(PricingEnum_1.PricingPassengerTyreSeasonEnum).WINTER_TYRE,
                                            label: (0, vue_2.unref)(i18n_1.trans)('winter_tyre', 'Winter tyre', 'new_pricing')
                                        }, null, 8, ["modelValue", "value", "label"]),
                                        (0, vue_2.createVNode)(PricingOptionRadio_vue_1.default, {
                                            modelValue: (0, vue_2.unref)(pricingStore).pricingPassengerTyreSeasonOption,
                                            "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event) => (((0, vue_2.unref)(pricingStore).pricingPassengerTyreSeasonOption) = $event)),
                                            value: (0, vue_2.unref)(PricingEnum_1.PricingPassengerTyreSeasonEnum).ALL_SEASON_TYRE,
                                            label: (0, vue_2.unref)(i18n_1.trans)('all_season_tyre', 'All season tyre', 'new_pricing')
                                        }, null, 8, ["modelValue", "value", "label"])
                                    ]))
                                    : (0, vue_2.createCommentVNode)("", true),
                                ((0, vue_2.unref)(pricingStore).pricingTyreCategoryOption === (0, vue_2.unref)(PricingEnum_1.PricingTyreCategoryEnum).TRUCK_TYRES)
                                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_17, [
                                        (0, vue_2.createVNode)(PricingOptionRadio_vue_1.default, {
                                            modelValue: (0, vue_2.unref)(pricingStore).pricingTruckTyreTypeOption,
                                            "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event) => (((0, vue_2.unref)(pricingStore).pricingTruckTyreTypeOption) = $event)),
                                            value: (0, vue_2.unref)(PricingEnum_1.PricingTruckTyreTypeEnum).TUBELESS_TYRE,
                                            label: (0, vue_2.unref)(i18n_1.trans)('tubeless_tyre', 'Tubeless tyre', 'new_pricing')
                                        }, null, 8, ["modelValue", "value", "label"]),
                                        (0, vue_2.createVNode)(PricingOptionRadio_vue_1.default, {
                                            modelValue: (0, vue_2.unref)(pricingStore).pricingTruckTyreTypeOption,
                                            "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event) => (((0, vue_2.unref)(pricingStore).pricingTruckTyreTypeOption) = $event)),
                                            value: (0, vue_2.unref)(PricingEnum_1.PricingTruckTyreTypeEnum)._20_INCHES_TYRE,
                                            label: (0, vue_2.unref)(i18n_1.trans)('20_inches_tyre', '20 inches tyre', 'new_pricing')
                                        }, null, 8, ["modelValue", "value", "label"]),
                                        (0, vue_2.createVNode)(PricingOptionRadio_vue_1.default, {
                                            modelValue: (0, vue_2.unref)(pricingStore).pricingTruckTyreTypeOption,
                                            "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event) => (((0, vue_2.unref)(pricingStore).pricingTruckTyreTypeOption) = $event)),
                                            value: (0, vue_2.unref)(PricingEnum_1.PricingTruckTyreTypeEnum).RETREADED_TYRE,
                                            label: (0, vue_2.unref)(i18n_1.trans)('retreaded_tyre', 'Retreaded tyre', 'new_pricing')
                                        }, null, 8, ["modelValue", "value", "label"])
                                    ]))
                                    : (0, vue_2.createCommentVNode)("", true),
                                ((0, vue_2.unref)(pricingStore).pricingTyreCategoryOption === (0, vue_2.unref)(PricingEnum_1.PricingTyreCategoryEnum).RIMS)
                                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_18, [
                                        (0, vue_2.createVNode)(PricingOptionRadio_vue_1.default, {
                                            modelValue: (0, vue_2.unref)(pricingStore).pricingRimCategoryOption,
                                            "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event) => (((0, vue_2.unref)(pricingStore).pricingRimCategoryOption) = $event)),
                                            value: (0, vue_2.unref)(PricingEnum_1.PricingRimCategoryEnum).ALLOY_RIM,
                                            label: (0, vue_2.unref)(i18n_1.trans)('alloy_rim', 'Alloy rim', 'new_pricing')
                                        }, null, 8, ["modelValue", "value", "label"]),
                                        (0, vue_2.createVNode)(PricingOptionRadio_vue_1.default, {
                                            modelValue: (0, vue_2.unref)(pricingStore).pricingRimCategoryOption,
                                            "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event) => (((0, vue_2.unref)(pricingStore).pricingRimCategoryOption) = $event)),
                                            value: (0, vue_2.unref)(PricingEnum_1.PricingRimCategoryEnum).STEEL_RIM,
                                            label: (0, vue_2.unref)(i18n_1.trans)('steel_rim', 'Steel rim', 'new_pricing')
                                        }, null, 8, ["modelValue", "value", "label"]),
                                        (0, vue_2.createVNode)(PricingOptionRadio_vue_1.default, {
                                            modelValue: (0, vue_2.unref)(pricingStore).pricingRimCategoryOption,
                                            "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event) => (((0, vue_2.unref)(pricingStore).pricingRimCategoryOption) = $event)),
                                            value: (0, vue_2.unref)(PricingEnum_1.PricingRimCategoryEnum).TWIN_WHEELS,
                                            label: (0, vue_2.unref)(i18n_1.trans)('twin_wheels', 'Twin wheels', 'new_pricing')
                                        }, null, 8, ["modelValue", "value", "label"]),
                                        (0, vue_2.createVNode)(PricingOptionRadio_vue_1.default, {
                                            modelValue: (0, vue_2.unref)(pricingStore).pricingRimCategoryOption,
                                            "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event) => (((0, vue_2.unref)(pricingStore).pricingRimCategoryOption) = $event)),
                                            value: (0, vue_2.unref)(PricingEnum_1.PricingRimCategoryEnum).AGRICULTURAL_RIM,
                                            label: (0, vue_2.unref)(i18n_1.trans)('agricultural_rim', 'Agricultural rim', 'new_pricing')
                                        }, null, 8, ["modelValue", "value", "label"])
                                    ]))
                                    : (0, vue_2.createCommentVNode)("", true)
                            ]))
                            : (0, vue_2.createCommentVNode)("", true)
                    ]),
                    _: 1
                }),
                (0, vue_2.createVNode)(vue_2.Transition, { name: "fade" }, {
                    default: (0, vue_2.withCtx)(() => [
                        (showPricingNameField())
                            ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_19, [
                                (0, vue_2.createElementVNode)("div", _hoisted_20, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)(`pricing_step_${pricingNameStep.value}_name`, `Step ${pricingNameStep.value}: Enter the name`, 'percent_pricing')), 1),
                                (0, vue_2.createVNode)((0, vue_2.unref)(Form_1.ShopInput), {
                                    modelValue: (0, vue_2.unref)(pricingStore).pricingName,
                                    "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event) => (((0, vue_2.unref)(pricingStore).pricingName) = $event)),
                                    border: ""
                                }, null, 8, ["modelValue"])
                            ]))
                            : (0, vue_2.createCommentVNode)("", true)
                    ]),
                    _: 1
                }),
                (0, vue_2.createVNode)(vue_2.Transition, { name: "fade" }, {
                    default: (0, vue_2.withCtx)(() => [
                        ((0, vue_2.unref)(pricingStore).pricingName && showPricingNameField())
                            ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_21, [
                                (0, vue_2.createElementVNode)("button", {
                                    class: "btn btn-rounded btn-primary",
                                    onClick: _cache[21] || (_cache[21] = ($event) => (createPricing()))
                                }, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)('next', 'Next', 'new_pricing')), 1)
                            ]))
                            : (0, vue_2.createCommentVNode)("", true)
                    ]),
                    _: 1
                })
            ]));
        };
    }
});
